/**
 * Runtime configuration, resolved at build time from REACT_APP_* variables.
 *
 * Defaults are the PRODUCTION values so a build with no env vars behaves
 * exactly as before. Override per environment via:
 *   - .env.development  → `npm start` (localhost against the dev stage)
 *   - shell exports      → deploy/frontend.sh dev|prod
 *
 * Never put secrets here: everything in this file ships to the browser.
 */

const env = (key, fallback) => {
  const v = process.env[key];
  return v === undefined || v === '' ? fallback : v;
};

const isDevServer = process.env.NODE_ENV === 'development';

const config = {
  // Backend (API Gateway). Prod uses the custom domain; dev uses the raw stage URL.
  API_URL: env('REACT_APP_API_URL', 'https://api.cidadao.acig-guapiacu.com.br'),

  // Where the SPA itself is served; used for OAuth redirect/logout URIs.
  APP_URL: env('REACT_APP_APP_URL', isDevServer ? 'http://localhost:3003/' : 'https://cidadao.acig-guapiacu.com.br/'),

  COGNITO_REGION: env('REACT_APP_COGNITO_REGION', 'us-east-2'),
  COGNITO_USER_POOL_ID: env('REACT_APP_COGNITO_USER_POOL_ID', 'us-east-2_WPbzJblbW'),
  COGNITO_CLIENT_ID: env('REACT_APP_COGNITO_CLIENT_ID', '5e6a7158uulr80o0uasroipjl0'),

  // Hosted UI domain (used only while AUTH_MODE === 'hosted').
  COGNITO_DOMAIN: env('REACT_APP_COGNITO_DOMAIN', 'https://auth.acig-guapiacu.com.br'),

  // 'hosted' = Cognito Hosted UI via react-oidc-context (current behaviour)
  // 'custom' = SPA-owned auth pages via amazon-cognito-identity-js (Etapa A)
  AUTH_MODE: env('REACT_APP_AUTH_MODE', 'hosted'),
};

config.COGNITO_AUTHORITY = `https://cognito-idp.${config.COGNITO_REGION}.amazonaws.com/${config.COGNITO_USER_POOL_ID}`;

export default config;
